// extracted by mini-css-extract-plugin
module.exports = {"light":"Wrapper_light__35iaY","card":"Wrapper_card__2DJWB","loaderBlock":"Wrapper_loaderBlock__27pbe","noData":"Wrapper_noData__1q7Qv","sourceList":"Wrapper_sourceList__2rUmM"};